import {Box, Heading, HStack, Show, Space, Text} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface AuctionCountdownBoxesProps extends TestIdProps {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const PAD_LENGTH = 2;
const PAD_CHAR = '0';

function padValue(value: number): string {
  return String(value).padStart(PAD_LENGTH, PAD_CHAR);
}

export function AuctionCountdown(props: AuctionCountdownBoxesProps) {
  const segments = [
    {value: props.days, label: i18n.t('general.metric.d'), testId: 'days'},
    {value: props.hours, label: i18n.t('general.metric.h'), testId: 'hours'},
    {value: props.minutes, label: i18n.t('general.metric.m'), testId: 'minutes'},
    {value: props.seconds, label: i18n.t('general.metric.s'), testId: 'seconds'},
  ];

  return (
    <Box
      backgroundColor="palettes.green.10.100"
      borderRadius="medium"
      paddingVertical={2}
      paddingHorizontal={4}
    >
      <HStack spacing={3} align="center" justify="center" wrap>
        {segments.map((segment) => (
          // The separator sits inside its segment so a wrap cannot leave it dangling alone.
          <HStack key={segment.testId} align="center" spacing={1}>
            <Heading size={2} data-testid={suffixTestId(`countdownValue-${segment.testId}`, props)}>
              {padValue(segment.value)}
            </Heading>
            <Text
              size="small"
              color="primary"
              data-testid={suffixTestId(`countdownLabel-${segment.testId}`, props)}
            >
              {segment.label}
            </Text>
            <Show when={segment.testId === 'days'}>
              {/* Restores the outer row's spacing={3} gap before the separator. */}
              <Space horizontal={1} />
              <Heading size={4} color="tertiary">
                ,
              </Heading>
            </Show>
            <Show when={['hours', 'minutes'].includes(segment.testId)}>
              <Space horizontal={1} />
              <Heading size={4} color="tertiary">
                :
              </Heading>
            </Show>
          </HStack>
        ))}
      </HStack>
    </Box>
  );
}
